import React, { useState } from "react";
import "./NewsletterCard.scss";
import PropTypes from "prop-types";
import { convert, showError, showSuccess } from "Services/functions";
import {
  getCustomIcon,
  getListOfUsers,
  getNumberOfUsers,
} from "Services/newsletterFunctions";
import Modal from "Components/Modal/Modal";
import { Tooltip } from "primereact/tooltip";
import parse from "html-react-parser";
import BtnBlanc from "Components/Boutons/BtnBlanc/btn-blanc";
import BtnBleu from "Components/Boutons/BtnBleu/btn-bleu";
import { connect } from "react-redux";
import { fetchDeleteUp } from "Services/api";

const NewsletterCard = (props) => {
  const [showUsers, setShowUsers] = useState(false);
  const [showPrevisu, setShowPrevisu] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const customIcon = getCustomIcon(props.contacts);

  const deleteList = async () => {
    const response = await fetchDeleteUp(`/newsletters/${props.data.id}`);
    if (response.error) {
      showError("Une erreur est survenue");
    } else {
      props.setAllNewsletters(
        props.allNewsletters.filter((item) => item.id !== props.data.id)
      );
      showSuccess("Votre newsletter a bien été supprimée");
    }
  };
  return (
    <div className="mynewsletters__card">
      <div className="mynewsletters__card__left">
        <div className="mynewsletters__card__left__title">
          {props.data.title}
        </div>
        <div className="mynewsletters__card__left__date">
          {"Créée le " + convert(props.data.createdAt)}
        </div>
        <div className="mynewsletters__card__left__members">
          Contacts : {props.contacts ? getNumberOfUsers(props.contacts) : 0}
        </div>
        {customIcon && (
          <img
            src={customIcon}
            alt=""
            className="customIcon"
            style={{ marginRight: "3rem" }}
          />
        )}
        {props.data.state.statusLabel == "Publié" && (
          <span className="actif">Publiée</span>
        )}
        {props.data.state.statusLabel == "Brouillon" && (
          <span className="brouillon">Brouillon</span>
        )}
      </div>
      <div className="mynewsletters__card__right">
        <Tooltip target=".mynewsletters__card__right__icon" />
        <div
          className="mynewsletters__card__right__icon pi pi-download"
          data-pr-tooltip="Charger la newsletter"
          data-pr-position="bottom"
          onClick={() => props.loadNewsletter(props.data, props.contacts)}
        ></div>
        <div
          className="mynewsletters__card__right__icon pi pi-eye"
          data-pr-tooltip="Prévisualiser"
          data-pr-position="bottom"
          onClick={() => setShowPrevisu(true)}
        ></div>
        <div
          className="mynewsletters__card__right__icon pi pi-trash"
          data-pr-tooltip="Supprimer la newsletter"
          data-pr-position="bottom"
          onClick={() => setIsDeleting(true)}
        ></div>
        {props.contacts?.codeEtapes?.length === 0 && (
          <div
            className="mynewsletters__card__right__icon pi pi-users"
            data-pr-tooltip="Liste des contacts"
            data-pr-position="bottom"
            onClick={() => {
              setShowUsers(true);
            }}
          ></div>
        )}
      </div>
      {showUsers && (
        <Modal
          visible={showUsers}
          setVisible={setShowUsers}
          header="Liste des contacts"
          className="modal newsletters"
        >
          <ul className="showUsersList" style={{ listStyle: "disc" }}>
            {props.contacts &&
              getListOfUsers(props.contacts).map((user, key) => (
                <li key={key}>
                  <span style={{ marginRight: "0.5rem" }}>
                    {user.firstname}
                  </span>
                  <span>{user.surname}</span>
                </li>
              ))}
          </ul>
        </Modal>
      )}
      {showPrevisu && (
        <Modal
          visible={showPrevisu}
          setVisible={setShowPrevisu}
          header="Aperçu de la newsletter"
          className="modal newsletters"
        >
          {parse(props.data.content)}
        </Modal>
      )}
      {isDeleting && (
        <Modal
          visible={isDeleting}
          setVisible={setIsDeleting}
          header="Supprimer la liste"
          className="modal newsletters deleteList"
        >
          <span>Êtes vous sûr(e) de vouloir supprimer cette newsletter ?</span>
          <div className="buttons">
            <BtnBlanc
              btnTexte="Oui"
              btnAction={() => {
                setIsDeleting(false);
                deleteList();
              }}
            ></BtnBlanc>
            <BtnBleu btnTexte="Non"></BtnBleu>
          </div>
        </Modal>
      )}
    </div>
  );
};

NewsletterCard.propTypes = {
  data: PropTypes.object,
  contacts: PropTypes.object,
  loadNewsletter: PropTypes.func,
  auth: PropTypes.object,
  allNewsletters: PropTypes.array,
  setAllNewsletters: PropTypes.func,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps)(NewsletterCard);
